import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { BehaviorSubject, first, Subject, takeUntil } from 'rxjs';

import { environment as env } from '../../../environments/environment';
import { LgvAPIService, LgvClientService, LgvSnapshotHelper, LgvUserService, NotificationService } from '../../core/core.module';
import { GreaterThanZero } from '../../core/utility/lgv-form-validator';

@Component({
    selector: 'lus-edit-loan',
    templateUrl: './edit-loan.component.html',
    styleUrls: ['./edit-loan.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditLoanComponent implements OnInit, OnDestroy {

    @Output() OnEditLoanStatusChanged: EventEmitter<string> = new EventEmitter();

    IsRefi: boolean = false;
    _form: UntypedFormGroup;
    IsReady: boolean = false;

    _EditLoanStatus: string = "Default";
    EditLoanStatus$ = new BehaviorSubject(this._EditLoanStatus);
    onDestroy$ = new Subject();

    constructor(
        private http: HttpClient,
        private LgvClientSvc: LgvClientService,
        private FB: UntypedFormBuilder,
        public SSHlpr: LgvSnapshotHelper,
        public Notifications: NotificationService,
        public LgvUserSvc: LgvUserService,
        private LgvApiSvc: LgvAPIService) {
    }

    ngOnInit() {
        let model = {
            estimatedBalance: 0,
            interestRate: 0,
            purchasePrice: 0,
            otherLoanBalance: 0
        }

        try {
            model.estimatedBalance = Math.round(this.SSHlpr.LA.estimatedBalance);
            model.interestRate = this.SSHlpr.LA.interestRate;
            model.purchasePrice = this.SSHlpr.LA.estimatedHomeValue;
            model.otherLoanBalance = this.SSHlpr.Loan.loanInfo.otherLoanBalance;
            this.IsRefi = this.SSHlpr.Loan.loanPurposeType.name.toLocaleLowerCase() !== "purchase";
        }
        catch (ex) {
        }

        this._form = this.FB.group({
            estimatedBalance: [null, [Validators.required, GreaterThanZero()]],
            interestRate: [null, [Validators.required, GreaterThanZero()]],
            purchasePrice: [null, [Validators.required, GreaterThanZero()]],
            otherLoanBalance: [null, []]
        });

        this._form.patchValue(model);
        this.IsReady = true;
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    OnUpdateLoan() {

        this.EditLoanStatus$.next("Updating");

        let model = this._form.getRawValue();

        // if this is a PublicRecord loan, flag it as confirmed
        model.confirmPublicRecord = true;

        this.IsReady = true;
        let loanID = this.SSHlpr.LA.loanId;
        let bldUrl = `${env.LgvApiBaseUrl}/user/client/loans/${loanID}`;
        if (!this.LgvApiSvc.IsClient) {
            bldUrl = `${env.LgvApiBaseUrl}/clients/${this.LgvClientSvc.ClientID$.value}/loans/${loanID}`;
        }

        this.http.patch<any>(bldUrl, model).pipe(takeUntil(this.onDestroy$)).subscribe(x => {
            //console.log('Loan update Result:');
            //console.log(x);

            if (!this.LgvApiSvc.IsClient) {
                this.LgvClientSvc.LoadSnapshotForNonClient(this.LgvClientSvc.ClientID$.value, true);
            } else {
                this.LgvClientSvc.LoadSnapshotForClient();
            }

            if (x) {

                //this.onNoClick();
                this.IsReady = false;

                this.LgvClientSvc.PostPageClick("Client updated loan information").pipe(first()).subscribe();

                this.EditLoanStatus$.next(x);
                this.OnEditLoanStatusChanged.emit("Success");
            }
        },
            err => {
                this.Notifications.error("There was an error trying to update your Loan Info.")
                this.IsReady = false;
                //this.onNoClick();

                this.EditLoanStatus$.next(err);

            }
        );
        return this.EditLoanStatus$;

    }

    OnIsRefiChange(event: MatRadioChange) {
        this.IsRefi = event.value === 'refi';
    }
    onSubmit() {
        if (this._form.invalid) { return; }
        return this.OnUpdateLoan();
    }

}

export class LoanEditModel {
    purchasePrice: number;
    interestRate: number;
    estimatedBalance: number;
    otherLoanBalance: number;
}
